import { render, staticRenderFns } from "./TcRefuse.vue?vue&type=template&id=6fb65334&scoped=true"
import script from "./TcRefuse.vue?vue&type=script&lang=js"
export * from "./TcRefuse.vue?vue&type=script&lang=js"
import style0 from "./TcRefuse.vue?vue&type=style&index=0&id=6fb65334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb65334",
  null
  
)

export default component.exports